import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { trimEnd } from 'lodash-es';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { LooseObject } from '../objects/loose-object';

@Injectable({
  providedIn: 'root'
})
export class ProfitabilityAnalystService {
  /**
   * @param {HttpClient} http
   */
  constructor(
    protected readonly http: HttpClient
  ) {}

  /**
   * get cont
   *
   * @param   {string} contractId
   *
   * @returns {Observable<LooseObject>}
   */
  getProfitabilityAnalysis(module: string, moduleId: string): Observable<LooseObject> {
    const params = new URLSearchParams;

    params.append('module', module);
    params.append('module_id', moduleId);

    return this.http.post<LooseObject>(`${trimEnd(environment.url, '/')}/profitability_analysis/${module}`, params.toString(), {
      observe: 'response'
    }).pipe(
      map(({ body }) => body)
    );
  }

  customerAnalyze(customerId: string): Observable<LooseObject> {
    const params = new URLSearchParams;

    params.append('customerId', customerId);

    return this.http.post<LooseObject>(`${trimEnd(environment.url, '/')}/profitability_analysis/customers`, params.toString(), {
      observe: 'response'
    }).pipe(
      map(({ body }) => body)
    );
  }
}